export default __webpack_public_path__ + "afb33c9218b09bd795148cc4d54f5af6.png";